/**
 * Before/After comparison slider
 * - Works with mouse (pointer), touch, and keyboard
 * - Uses clip-path + CSS custom property updates inside requestAnimationFrame
 *   so dragging never triggers layout/reflow -> smooth on all devices
 * - Idempotent init: safe to call again on Shopify theme-editor section reloads
 */
(function () {
  function initBcaSlider(root) {
    if (!root || root.dataset.bcaInitialized === 'true') return;

    var slider = root.querySelector('[data-bca-slider]');
    var before = root.querySelector('[data-bca-before]');
    var divider = root.querySelector('[data-bca-divider]');
    var handle = root.querySelector('[data-bca-handle]');

    if (!slider || !before || !divider || !handle) return;
    root.dataset.bcaInitialized = 'true';

    var pos = 50; // current percentage, 0-100
    var pendingPos = null; // next frame's target percentage
    var rafId = null;
    var dragging = false;

    function render() {
      rafId = null;
      if (pendingPos === null) return;
      pos = pendingPos;
      pendingPos = null;

      var clipRight = (100 - pos).toFixed(2) + '%';
      before.style.clipPath = 'inset(0 ' + clipRight + ' 0 0)';
      divider.style.left = pos + '%';
      handle.style.left = pos + '%';
      slider.setAttribute('aria-valuenow', Math.round(pos));
    }

    function scheduleRender(nextPos) {
      pendingPos = Math.min(100, Math.max(0, nextPos));
      if (rafId === null) {
        rafId = requestAnimationFrame(render);
      }
    }

    function percentFromClientX(clientX) {
      var rect = slider.getBoundingClientRect();
      var x = clientX - rect.left;
      return (x / rect.width) * 100;
    }

    function onPointerDown(e) {
      dragging = true;
      slider.setPointerCapture && e.pointerId != null && slider.setPointerCapture(e.pointerId);
      scheduleRender(percentFromClientX(e.clientX));
      e.preventDefault();
    }

    function onPointerMove(e) {
      if (!dragging) return;
      scheduleRender(percentFromClientX(e.clientX));
    }

    function onPointerUp() {
      dragging = false;
    }

    // Pointer events cover mouse + touch + pen in one code path (smoothest, no duplicate handling)
    if (window.PointerEvent) {
      slider.addEventListener('pointerdown', onPointerDown);
      slider.addEventListener('pointermove', onPointerMove);
      window.addEventListener('pointerup', onPointerUp);
      window.addEventListener('pointercancel', onPointerUp);
    } else {
      // Fallback for older browsers without Pointer Events support
      slider.addEventListener('mousedown', function (e) {
        dragging = true;
        scheduleRender(percentFromClientX(e.clientX));
      });
      window.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        scheduleRender(percentFromClientX(e.clientX));
      });
      window.addEventListener('mouseup', onPointerUp);

      slider.addEventListener(
        'touchstart',
        function (e) {
          dragging = true;
          var t = e.touches[0];
          scheduleRender(percentFromClientX(t.clientX));
        },
        { passive: true }
      );
      slider.addEventListener(
        'touchmove',
        function (e) {
          if (!dragging) return;
          var t = e.touches[0];
          scheduleRender(percentFromClientX(t.clientX));
        },
        { passive: true }
      );
      window.addEventListener('touchend', onPointerUp);
      window.addEventListener('touchcancel', onPointerUp);
    }

    // Click/tap anywhere on the slider to jump the divider to that point
    slider.addEventListener('click', function (e) {
      if (dragging) return;
      scheduleRender(percentFromClientX(e.clientX));
    });

    // Keyboard accessibility: arrow keys move the divider in 2% steps
    slider.addEventListener('keydown', function (e) {
      var step = e.shiftKey ? 10 : 2;
      if (e.key === 'ArrowLeft') {
        scheduleRender(pos - step);
        e.preventDefault();
      } else if (e.key === 'ArrowRight') {
        scheduleRender(pos + step);
        e.preventDefault();
      } else if (e.key === 'Home') {
        scheduleRender(0);
        e.preventDefault();
      } else if (e.key === 'End') {
        scheduleRender(100);
        e.preventDefault();
      }
    });

    // Initial paint
    scheduleRender(50);
  }

  window.initBcaSlider = initBcaSlider;

  // Auto-init any instances already in the DOM (non-theme-editor pageloads)
  document.querySelectorAll('.bca-section').forEach(function (el) {
    initBcaSlider(el);
  });
})();